import * as React from 'react';
import { connect } from 'react-redux';
import SecondaryToolbar from '../common/SecondaryToolbar';
import { ToolbarDirection } from '../../actions/UIModeAction';
import { Dispatch, Action } from 'redux';
import UIAction from '../../actions/ui/UIAction';
import IconButton from '../common/IconButton';
import { SecondaryToolbarType } from '../header-toolbar/NewHeaderToolbar';

interface ReflowableContentMarkerSettingSecondaryLevelProps {
  readonly direction: ToolbarDirection;
  readonly dispatch: Dispatch<Action>;
  readonly setSecondaryToolbarType: (secondaryToolbarType: SecondaryToolbarType) => void;
}

const ReflowableContentMarkerSettingSecondaryLevel: React.SFC<
  ReflowableContentMarkerSettingSecondaryLevelProps
> = React.memo((props) => {
  const { dispatch } = props;

  return (
    <SecondaryToolbar direction={props.direction}>
      <IconButton
        title="黒"
        rouondRect={true}
        imagePath="images/tool-icons/new/marker_black/marker_black"
        onClick={() => UIAction.setMarkerSelectedColorIndex(0, dispatch)} />

      <IconButton
        title="青"
        rouondRect={true}
        imagePath="images/tool-icons/new/marker_blue/marker_blue"
        onClick={() => UIAction.setMarkerSelectedColorIndex(1, dispatch)} />

      <IconButton
        title="緑"
        rouondRect={true}
        imagePath="images/tool-icons/new/marker_green/marker_green"
        onClick={() => UIAction.setMarkerSelectedColorIndex(2, dispatch)} />

      <IconButton
        title="赤"
        rouondRect={true}
        imagePath="images/tool-icons/new/marker_red/marker_red"
        onClick={() => UIAction.setMarkerSelectedColorIndex(3, dispatch)} />

      <IconButton
        title="黄"
        rouondRect={true}
        imagePath="images/tool-icons/new/marker_yellow/marker_yellow"
        onClick={() => UIAction.setMarkerSelectedColorIndex(4, dispatch)} />

      <IconButton
        title="戻る"
        imagePath="images/tool-icons/new/btn_return/btn_return"
        rouondRect={true}
        onClick={() => props.setSecondaryToolbarType(SecondaryToolbarType.None)} />
    </SecondaryToolbar>
  );
});

export default connect()(ReflowableContentMarkerSettingSecondaryLevel);
